import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import QuantityControl from "../helper/QuantityControl";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const CartSection = ({ selectedCurrency }) => {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const TAX = 0;
  const DELIVERY = 0;
  let token = localStorage.getItem("authToken");

  const getData = async () => {
    const locart = localStorage.getItem("cart");
    const localCartArray = locart ? JSON.parse(locart) : [];
    setCart(localCartArray);

    if (token) {
      let cartdata = await axios.get(`${API_URL}/cart`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const backendCart = cartdata.data.cart || [];
      if (localCartArray.length < backendCart.length) {
        setCart(backendCart);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
  if (!cart.length) return;

  const updatedCart = cart.map((item) => ({
    ...item,

    currency: selectedCurrency,

    price:
      item.allPrices?.[selectedCurrency] ||
      item.allPrices?.INR ||
      item.price,
  }));

  setCart(updatedCart);

  localStorage.setItem("cart", JSON.stringify(updatedCart));
}, [selectedCurrency]);

  const handleQuantityChange = async (index, newQty) => {
    const updatedCart = [...cart];
    updatedCart[index].qty = newQty;

    if (token) {
      await axios.post(
        `${API_URL}/cart/sync`,
        { cart: updatedCart },
        { headers: { Authorization: `Bearer ${token}` } },
      );
    }

    if (newQty === 0) updatedCart.splice(index, 1);
    else updatedCart[index].qty = newQty;

    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const calculateSubtotal = (item) => {
    const currentPrice = item.allPrices?.[selectedCurrency] || 0;
    return currentPrice * item.qty;
  };

  const calculateTotal = () =>
    cart.reduce((sum, item) => sum + calculateSubtotal(item), 0);

  const handleCheckout = () => {
    if (token) navigate("/checkout");
    else navigate("/account");
  };

  if (!cart || cart.length === 0)
    return (
      <section className="cart py-80">
        <div className="container container-lg text-center">
          <h2>Your cart is empty</h2>
          <Link to="/" className="btn btn-main mt-24">
            Continue Shopping
          </Link>
        </div>
      </section>
    );

  return (
    <section className="cart py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-9 col-lg-8">
            <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-three">
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>

                  <tbody>
                    {cart.map((item, key) => (
                      <tr key={item.id}>
                        {/* PRODUCT COLUMN */}
                        <td>
                          <div className="table-product d-flex align-items-center gap-24">
                            <Link
                              to={`/product-details/${item.id}`}
                              className="table-product__thumb border border-gray-100 rounded-8 flex-center "
                            >
                              <img src={item.image} alt={item.name} />
                              {/* <img
                                src={
                                  item?.variant?.images?.[0] ||
                                  item?.images?.[0] ||
                                  "/no-image.png"
                                }
                                alt={item.name}
                              /> */}
                            </Link>

                            <div className="table-product__content text-start">
                              <h6 className="title text-lg fw-semibold mb-8">
                                <Link
                                  to={`/product-details/${item.id}`}
                                  className="link text-line-2"
                                >
                                  {item.name}
                                </Link>
                              </h6>

                              {/* === SHOW SELECTED SIZE === */}
                              {item.hasSize && item.size && (
                                <p className="text-sm text-gray-600">
                                  Size:{" "}
                                  <span className="fw-semibold">
                                    {item.size}
                                  </span>
                                </p>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* PRICE */}
                        <td>
                          <span className="text-heading text-md fw-semibold">
                            {selectedCurrency}{" "}
                            {(
                              item.allPrices?.[selectedCurrency] ||
                              item.allPrices?.INR ||
                              item.price
                            ).toFixed(2)}
                          </span>
                        </td>

                        {/* QUANTITY */}
                        <td>
                          <QuantityControl
                            productId={item.id}
                            initialQuantity={item.qty}
                            onQuantityChange={(newQty) =>
                              handleQuantityChange(key, newQty)
                            }
                            productKey={key}
                          />
                        </td>

                        {/* SUBTOTAL */}
                        <td>
                          <span className="text-heading text-md fw-semibold">
                            {selectedCurrency}{" "}
                            {calculateSubtotal(item).toFixed(2)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* SIDEBAR */}
          <div className="col-xl-3 col-lg-4">
            <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
              <h6 className="text-xl mb-32">Cart Totals</h6>

              <div className="bg-color-three rounded-8 p-24">
                <div className="mb-16 flex-between">
                  <span className="text-gray-900">Subtotal</span>
                  <span className="text-gray-900 fw-semibold">
                    {selectedCurrency} {calculateTotal().toFixed(2)}
                  </span>
                </div>

                <div className="mb-16 flex-between">
                  <span className="text-gray-900">Estimated Delivery</span>
                  <span className="text-gray-900 fw-semibold">
                    {selectedCurrency} {DELIVERY.toFixed(2)}
                  </span>
                </div>

                <div className="flex-between">
                  <span className="text-gray-900">Estimated Taxes</span>
                  <span className="text-gray-900 fw-semibold">
                    {selectedCurrency} {TAX.toFixed(2)}
                  </span>
                </div>
              </div>

              <div className="bg-color-three rounded-8 p-24 mt-24">
                <div className="flex-between">
                  <span className="text-gray-900 text-xl fw-semibold">
                    Total
                  </span>
                  <span className="text-gray-900 text-xl fw-semibold">
                    {selectedCurrency}{" "}
                    {(calculateTotal() + TAX + DELIVERY).toFixed(2)}
                  </span>
                </div>
              </div>

              <button
                onClick={handleCheckout}
                className="btn btn-main mt-40 py-18 w-100 rounded-8"
              >
                Proceed to checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartSection;
